import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ICreateChallengeBody } from './create-challenge-request';
import type { ICreateChallengeResponse } from './create-challenge-response';
import { createChallengeResponseSchema } from './create-challenge-response';

export async function createChallengeApi(
  body: ICreateChallengeBody,
): Promise<IValidatedResponse<ICreateChallengeResponse>> {
  return postRequest<ICreateChallengeResponse>({
    path: '/sys/challenges',
    body,
    schema: createChallengeResponseSchema,
  });
}
